import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineErrorComponent } from 'src/app/shared/components/inline-error/inline-error.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule],
  exports: [InlineErrorComponent],
  declarations: [InlineErrorComponent],
})
export class InlineErrorModule {}
